function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "param(fill) #CD9834",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0c11.021 0 20 8.979 20 20s-8.979 20-20 20S0 31.021 0 20 8.979 0 20 0zm0 1.569C9.845 1.569 1.569 9.845 1.569 20c0 10.155 8.276 18.431 18.431 18.431 10.155 0 18.431-8.276 18.431-18.431C38.431 9.845 30.155 1.569 20 1.569z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.975 11.432l-8.557-.062v1.532l5.864.026-13.33 13.357-.035-6.344-1.532-.001.063 8.583 8.556.062v-1.532l-5.416-.025 12.883-12.911.034 5.897 1.532.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.107 12.21h.09v.07L12.761 27.747l-.536-.004-.006-.753.57.57z"
}));
function SvgMoreViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgMoreViews;